import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from './services/api';

export default function AuthPingWatcher({ setToken }) {
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const response = await api.get('/auth/ping');
        if (response.status !== 200) {
          setToken(null);
          window.localStorage.removeItem('token');
          window.sessionStorage.removeItem('token');
          navigate('/login');
        }
      } catch (e) {
        setToken(null);
        window.localStorage.removeItem('token');
        window.sessionStorage.removeItem('token');
        navigate('/login');
      }
    }, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [navigate, setToken]);

  return null;
}
